import MenuDataTagSelect from "@/Pages/Auth/Admin/MenuDataTags/MenuDataTagSelect";
import { MenuDataTagKind, MenuItem } from "@/shared/utils/interfaces";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
  kind: MenuDataTagKind;
  defaultValue?: Partial<MenuItem>;
  // Not every menu item has a size or variants, only the fields asked for are shown and sent
  showDataTag?: boolean;
  showSize?: boolean;
  showVariants?: boolean;
}

// Data, size and variant tags of a menu item, clearing a select sends null ( or [] ) to remove the tag
const MenuDataTagFields = ({
  kind,
  defaultValue,
  showDataTag = true,
  showSize = false,
  showVariants = false,
}: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <div className="grid gap-8 md:grid-cols-2">
      {showDataTag && (
        <Controller
          name="menu_data_tag_id"
          control={control}
          defaultValue={defaultValue?.menu_data_tag_id ?? null}
          render={({ onChange, value }) => (
            <MenuDataTagSelect
              label={t("menuDataTags.dataTag")}
              kind={kind}
              value={value ?? null}
              onChange={onChange}
            />
          )}
        />
      )}
      {showSize && (
        <Controller
          name="menu_data_size_tag_id"
          control={control}
          defaultValue={defaultValue?.menu_data_size_tag_id ?? null}
          render={({ onChange, value }) => (
            <MenuDataTagSelect
              label={t("menuDataTags.sizeTag")}
              kind={MenuDataTagKind.SIZE}
              value={value ?? null}
              onChange={onChange}
            />
          )}
        />
      )}
      {showVariants && (
        <Controller
          name="menu_data_variant_tag_ids"
          control={control}
          defaultValue={defaultValue?.menu_data_variant_tag_ids ?? []}
          render={({ onChange, value }) => (
            <MenuDataTagSelect
              isMulti
              label={t("menuDataTags.variantTags")}
              kind={MenuDataTagKind.VARIANT}
              value={value ?? []}
              onChange={onChange}
            />
          )}
        />
      )}
    </div>
  );
};

export default MenuDataTagFields;
